import { useAccountBuyerGetAnimals } from '@application/api';

export const useGetAnimals = (archived = false) => {
  const getAnimals = useAccountBuyerGetAnimals({ archived });

  return { ...getAnimals };
};
